import { render, staticRenderFns } from "./SidebarControlConfiguration.vue?vue&type=template&id=19b12ddd&scoped=true"
import script from "./SidebarControlConfiguration.vue?vue&type=script&lang=js"
export * from "./SidebarControlConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SidebarControlConfiguration.vue?vue&type=style&index=0&id=19b12ddd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b12ddd",
  null
  
)

export default component.exports